export const regNoEntered =  {
    eventCategory: "homepage_dweb",
    event: "reg_no_entered",
    eventAction: "reg_number_entered"
};

export const repeatInspection = {
    event: "repeat_inspection",
    eventCategory: "repeat_user_reg"
};
